(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5d03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5d03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("71MPf", function(module, exports) {

$parcel$export(module.exports, "initServicesList", () => $51de802038f49ab9$export$22e75ef7dd469ed8);
// import { setLinesWrapper } from "../modules/setLinesWrapper";
function $51de802038f49ab9$export$22e75ef7dd469ed8() {
    const servicesItems = document.querySelectorAll(".services-list-item");
    if (!servicesItems) return;
    servicesItems.forEach((item)=>{
        const line = item.querySelector(".services-list-item-line"), heading = item.querySelector("h3"), description = item.querySelector(".services-list-item-description > p"), button = item.querySelector(".button");
        let headingEls, descriptionEls;
        SplitText.create(heading, {
            type: "lines, words",
            mask: "lines",
            wordsClass: "word",
            linesClass: "line",
            autoSplit: true,
            onSplit: (self)=>{
                headingEls = heading.querySelectorAll(".word");
                gsap.set(headingEls, {
                    yPercent: 100
                });
            }
        });
        // const headingLines = new SplitType(heading, {
        //   types: "lines, words",
        //   tagName: "span",
        // });
        SplitText.create(description, {
            type: "lines",
            mask: "lines",
            linesClass: "line",
            autoSplit: true,
            onSplit: (self)=>{
                descriptionEls = description.querySelectorAll(".line");
                gsap.set(descriptionEls, {
                    yPercent: 100
                });
            }
        });
        // const descriptionLines = new SplitType(description, {
        //   types: "lines",
        //   tagName: "span",
        // });
        // setLinesWrapper(descriptionLines.lines, () => {
        //   descriptionEls = description.querySelectorAll(".line");
        //   gsap.set(descriptionEls, { yPercent: 100 });
        // });
        gsap.set(line, {
            scaleX: 0
        });
        gsap.set(button, {
            yPercent: 100
        });
        gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "top bottom-=20%",
                onEnter: ()=>{
                    const tl = gsap.timeline();
                    tl.to(line, {
                        scaleX: 1,
                        duration: 0.5,
                        ease: "expo.out"
                    }).to(headingEls, {
                        yPercent: 0,
                        stagger: 0.1,
                        duration: 0.5,
                        ease: "expo.out"
                    }, "-=0.25").to(descriptionEls, {
                        yPercent: 0,
                        stagger: 0.05,
                        ease: "expo.out"
                    }, "-=0.25").to(button, {
                        yPercent: 0,
                        duration: 0.3,
                        ease: "expo.out"
                    }, "-=0.25");
                }
            }
        });
    });
}

});

// import { setLinesWrapper } from "../modules/setLinesWrapper";
// Link timelines to scroll position
function $e8430b869ad88317$var$createBrandCoreTrigger(triggerElement, words, isLast, isDelayedStagger, index) {
    if (isDelayedStagger) {
        const height = triggerElement.getBoundingClientRect().height / window.outerHeight;
        words.forEach((word, i)=>{
            const start = i * 20;
            const end = start + 5;
            gsap.fromTo(word, {
                yPercent: 105
            }, {
                yPercent: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: triggerElement,
                    scrub: true,
                    start: `${start}% top`,
                    end: `${end}% top`,
                    markers: false,
                    pin: false
                }
            });
        });
    } else gsap.fromTo(words, {
        yPercent: 105
    }, {
        yPercent: 0,
        stagger: 0.1,
        ease: "none",
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: "top top",
            end: "25% top",
            markers: false,
            pin: false
        }
    });
    if (!isLast) {
        let start, end;
        if (isDelayedStagger) {
            const height = triggerElement.getBoundingClientRect().height / window.outerHeight;
            start = "70% top";
            end = "75% top";
        } else {
            start = "40% top";
            end = "50% top";
        }
        gsap.fromTo(words, {
            yPercent: 0
        }, {
            yPercent: -105,
            stagger: 0.1,
            ease: "none",
            immediateRender: false,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: start,
                end: end,
                markers: false,
                pin: false
            }
        });
    }
    if (isLast) {
        const button = triggerElement.querySelector(".button");
        gsap.set(button, {
            yPercent: 101
        });
        gsap.to(button, {
            yPercent: 0,
            ease: "none",
            immediateRender: false,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: "top top",
                end: "25% top",
                markers: false,
                pin: false
            }
        });
    }
}
function $e8430b869ad88317$export$a6972a2f8f6a85bb() {
    // Prevent onSplit initialization logic from running multiple times
    let hasRunSplitInit = false;
    // Split all words on the brand core section
    SplitText.create(".brand-core-text", {
        type: "lines, words",
        mask: "lines",
        wordsClass: "word",
        linesClass: "line",
        autoSplit: true,
        onSplit: (self)=>{
            if (hasRunSplitInit) return; // <-- only runs once per page load
            hasRunSplitInit = true;
            // gsap.set(".brand-core-text .word", { yPercent: 100 });
            const sections = document.querySelectorAll(".brand-core-step");
            sections.forEach((section, i)=>{
                const isDelayedStagger = section.classList.contains("_03");
                const words = section.querySelectorAll(".word");
                const isLast = i === sections.length - 1;
                $e8430b869ad88317$var$createBrandCoreTrigger(section, words, isLast, isDelayedStagger, i);
            });
        }
    });
}


function $4f8dd14eb30e4f23$export$985150dac2e59f14() {
    const canUseDOM = typeof window !== "undefined" && typeof document !== "undefined";
    // // Prevent onSplit initialization logic from running multiple times
    // let hasRunSplitInit = false;
    // // Split headline
    // SplitText.create(".hero-subheadline", {
    //   type: "lines",
    //   mask: "lines",
    //   linesClass: "line",
    //   autoSplit: true,
    //   onSplit: (self) => {
    //     if (hasRunSplitInit) return; // <-- only runs once per page load
    //     hasRunSplitInit = true;
    //     gsap.set(self.lines, { yPercent: 100 });
    //     setTimeout(() => {
    //       playHeroIntro();
    //     }, 50);
    //   },
    // });
    playHeroIntro();
    function playHeroIntro() {
        const header = document.querySelector(".header");
        const heroSection = document.querySelector(".section_home-hero");
        const heroVideo = heroSection.querySelector(".hero-video-bg video");
        const heroHeadline = heroSection.querySelector("[data-hero-headline]");
        const heroSubheadline = heroSection.querySelector("[data-hero-subheadline]");
        const heroCta = heroSection.querySelector(".button");
        const headlineSplit = SplitText.create(heroHeadline, {
            type: "words",
            mask: "words"
        });
        const subheadlineSplit = SplitText.create(heroSubheadline, {
            type: "words",
            mask: "words"
        });
        gsap.set(header, {
            yPercent: -100
        });
        gsap.set(headlineSplit.words, {
            yPercent: 100
        });
        gsap.set(subheadlineSplit.words, {
            yPercent: 100
        });
        gsap.set(heroCta, {
            yPercent: 110
        });
        // Intro timeline (starts paused)
        const tl = gsap.timeline({
            paused: true,
            onComplete: ()=>{
                if (canUseDOM) window.sessionStorage.setItem("heroIntroPlayed", "true");
            }
        });
        // Animation sequence --------------------------------------------
        tl.fromTo(".hero-words-wrapper", {
            y: "0%"
        }, {
            y: "-33.33%",
            duration: 1,
            ease: "expo.inOut"
        }).to(".hero-words-wrapper", {
            y: "-66.66%",
            duration: 1,
            ease: "expo.inOut"
        }).to(".hero-line._01", {
            height: 0,
            duration: 1,
            ease: "expo.inOut"
        }).to(headlineSplit.words, {
            yPercent: 0,
            duration: 1,
            ease: "expo.inOut"
        }, "-=0.5").to(subheadlineSplit.words, {
            yPercent: 0,
            duration: 1,
            ease: "expo.inOut"
        }, "-=1").to(heroCta, {
            yPercent: 0,
            duration: 1,
            ease: "expo.inOut"
        }, "-=0.5").to(header, {
            yPercent: 0,
            duration: 1,
            ease: "expo.inOut"
        }, "-=1.5").fromTo(".hero-video-bg", {
            opacity: 0
        }, {
            opacity: "100%",
            duration: 0.5,
            ease: "power4.Out",
            onStart: ()=>{
                heroVideo?.play();
            }
        }, "-=1.5");
        // .to(
        //   ".section-reels",
        //   {
        //     marginTop: "-12rem",
        //     duration: 0.5,
        //     ease: "power4.Out",
        //   },
        //   "-=0.5"
        // );
        // Check if intro was already played this session
        const hasSeenIntro = canUseDOM && window.sessionStorage.getItem("heroIntroPlayed") === "true";
        window.sessionStorage.setItem("heroIntroPlayed", "true");
        // Play or skip
        if (hasSeenIntro) // Jump straight to end state
        tl.progress(1);
        else // First visit: delay then play
        setTimeout(()=>tl.play(), 1000);
    }
}


function $1dba3710f09b7657$export$e8ae5caf6764b3bb() {
    const caseStudies = document.querySelectorAll(".case-study-item");
    const trigger = document.querySelector(".case-studies-wrapper");
    if (!caseStudies) return;
    // const mm = gsap.matchMedia();
    // let maskSizeStart = "0vw 0vw";
    // let maskSizeEnd = "200vw 200vw";
    // mm.add("(min-width: 768px)", () => {
    //   // desktop
    //   maskSizeStart = "0vw 0vw";
    //   maskSizeEnd = "200vw 200vw";
    // });
    // mm.add("(max-width: 767px)", () => {
    //   // mobile
    //   maskSizeStart = "0vh 0vh";
    //   maskSizeEnd = "200vh 200vh";
    // });
    // Case Studies animations ======================================== //
    caseStudies.forEach((el, i)=>{
        const tl = gsap.timeline();
        const projectId = el.dataset.project;
        // const trigger = document.querySelector(
        //   `.case-study-spacer[data-project="${projectId}"]`
        // );
        const mask = el.querySelector(".case-study-item-inner");
        const img = el.querySelector(".case-study-item-img");
        if (i === 0) {
            gsap.set(document.querySelector(".case-studies-overlay"), {
                opacity: 1
            });
            gsap.set(document.querySelector(".hero-video-bg-wrapper"), {
                opacity: 1
            });
            gsap.set(document.querySelector(".case-studies-overlay-text"), {
                y: "0rem"
            });
            gsap.set(document.querySelectorAll(".case-study-item-footer"), {
                opacity: 0
            });
            if (window.outerWidth > 767) {
                const wrapper = document.querySelector(".portfolio-sticky-wrapper");
                gsap.set(wrapper, {
                    y: "0rem",
                    width: "30%"
                });
                tl.to(wrapper, {
                    ease: "none",
                    // y: "12rem",
                    width: "100%",
                    scrollTrigger: {
                        trigger: trigger,
                        scrub: true,
                        start: "top bottom",
                        end: "top top"
                    }
                });
            }
            gsap.to(document.querySelectorAll(".case-study-item-footer"), {
                ease: "none",
                opacity: 1,
                scrollTrigger: {
                    trigger: trigger,
                    scrub: true,
                    start: "top bottom",
                    end: "top top"
                }
            });
            gsap.to(document.querySelector(".case-studies-overlay"), {
                ease: "none",
                opacity: 0,
                scrollTrigger: {
                    trigger: trigger,
                    scrub: true,
                    start: "top bottom",
                    end: "top center",
                    onLeave: ()=>{
                        gsap.set(document.querySelector(".case-studies-overlay"), {
                            display: "none"
                        });
                    },
                    onEnterBack: ()=>{
                        gsap.set(document.querySelector(".case-studies-overlay"), {
                            display: "block"
                        });
                    }
                }
            });
            gsap.to(document.querySelector(".case-studies-overlay-text"), {
                ease: "none",
                y: "-10rem",
                scrollTrigger: {
                    trigger: trigger,
                    scrub: true,
                    start: "top bottom",
                    end: "top center"
                }
            });
            gsap.to(document.querySelector(".hero-video-bg-wrapper"), {
                ease: "none",
                opacity: 0,
                scrollTrigger: {
                    trigger: document.querySelector(".section-hero"),
                    scrub: true,
                    start: "top top",
                    end: "bottom top"
                }
            });
            return;
        }
    // gsap.set(mask, {
    //   maskImage:
    //     "radial-gradient(circle at 50% 50%, black 50%, rgba(0, 0, 0, 0) 65%)",
    //   maskRepeat: "no-repeat",
    //   maskPosition: "center",
    //   maskSize: maskSizeStart,
    // });
    // gsap.set(mask, { display: "none" });
    // tl.to(mask, {
    //   ease: "none",
    //   maskSize: maskSizeEnd,
    //   scrollTrigger: {
    //     trigger: trigger,
    //     scrub: true,
    //     start: "top bottom",
    //     end: "100vh top",
    //   },
    // });
    // gsap.to(mask, {
    //   scrollTrigger: {
    //     trigger: trigger,
    //     scrub: true,
    //     start: "top bottom",
    //     end: "bottom top",
    //     onEnter: () => {
    //       gsap.set(mask, { display: "block" });
    //     },
    //     onEnterBack: () => {
    //       gsap.set(mask, { display: "block" });
    //     },
    //     onLeave: () => {
    //       gsap.set(mask, { display: "none" });
    //     },
    //     onLeaveBack: () => {
    //       gsap.set(mask, { display: "none" });
    //     },
    //   },
    // });
    // tl.from(img, {
    //   scale: 1.2,
    //   opacity: 0.5,
    //   ease: "none",
    //   scrollTrigger: {
    //     trigger: trigger,
    //     scrub: true,
    //     start: "top bottom",
    //     end: "bottom center",
    //   },
    // });
    });
}


function $7930e0919590fadc$export$e771ae7f2004877f() {
    const slider = document.querySelector(".case-studies-wrapper");
    const slides = [
        ...slider.querySelectorAll(".case-study-item")
    ];
    const nextBtn = document.querySelector(".case-studies-controls .next");
    const prevBtn = document.querySelector(".case-studies-controls .prev");
    const pagination = document.querySelector(".case-studies-pagination");
    const mm = gsap.matchMedia();
    let maskSizeStart = "0vw 0vw";
    let maskSizeEnd = "200vw 200vw";
    mm.add("(min-width: 768px)", ()=>{
        maskSizeStart = "0vw 0vw";
        maskSizeEnd = "200vw 200vw";
    });
    mm.add("(max-width: 767px)", ()=>{
        maskSizeStart = "0vh 0vh";
        maskSizeEnd = "200vh 200vh";
    });
    let current = 0;
    // Create bullets
    const bullets = slides.map((_, index)=>{
        const bullet = document.createElement("div");
        bullet.classList.add("case-studies_bullet");
        if (index === 0) bullet.classList.add("is-active");
        bullet.addEventListener("click", ()=>{
            goToSlide(index);
        });
        pagination?.appendChild(bullet);
        return bullet;
    });
    slides.forEach((slide, i)=>{
        const mask = slide.querySelector(".case-study-item-inner");
        const img = slide.querySelector(".case-study-item-img");
        const targets = slide.querySelectorAll("[data-slider-stagger]");
        targets.forEach((el)=>{
            SplitText.create(el, {
                type: "words",
                mask: "words",
                wordsClass: "word",
                autoSplit: true,
                onSplit: (self)=>{
                    if (i > 0) gsap.set(self.words, {
                        yPercent: 100
                    });
                }
            });
        });
        gsap.set(mask, {
            maskImage: "radial-gradient(circle at 50% 50%, black 50%, rgba(0, 0, 0, 0) 65%)",
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: i === 0 ? maskSizeEnd : maskSizeStart
        });
        if (i > 0) {
            gsap.set(mask, {
                display: "none"
            });
            gsap.set(img, {
                scale: 1.2
            });
        }
    });
    function updateBullets(index) {
        bullets.forEach((b, i)=>{
            b.classList.toggle("is-active", i === index);
        });
    }
    function animateTextIn(slide) {
        const targets = slide.querySelectorAll("[data-slider-stagger] .word");
        gsap.to(targets, {
            yPercent: 0,
            duration: 0.5,
            ease: "power2.out",
            stagger: 0.06
        });
    }
    function resetText(slide) {
        const targets = slide.querySelectorAll("[data-slider-stagger] .word");
        gsap.set(targets, {
            yPercent: 100
        });
    }
    function goToSlide(index) {
        if (index === current || gsap.isTweening(slides[current])) return;
        const currentSlide = slides[current];
        const currentMask = currentSlide.querySelector(".case-study-item-inner");
        const nextSlide = slides[index];
        const nextMask = nextSlide.querySelector(".case-study-item-inner");
        const img = nextSlide.querySelector(".case-study-item-img");
        gsap.killTweensOf([
            currentSlide,
            nextSlide
        ]);
        slides.forEach((slide)=>slide.classList.remove("is-current"));
        gsap.set(nextSlide, {
            zIndex: 2
        });
        gsap.set(currentSlide, {
            zIndex: 1
        });
        gsap.set(nextMask, {
            display: "block",
            maskSize: maskSizeStart
        });
        gsap.to(nextMask, {
            maskSize: maskSizeEnd,
            duration: 0.6,
            onStart: ()=>{
                nextSlide.classList.add("is-current");
                updateBullets(index);
            },
            onComplete: ()=>{
                gsap.set(currentSlide, {
                    zIndex: 1
                });
                gsap.set(currentMask, {
                    display: "none"
                });
                resetText(currentSlide);
                animateTextIn(nextSlide);
                current = index;
            }
        });
        gsap.to(img, {
            scale: 1,
            duration: 0.6,
            ease: "power2.out"
        });
    }
    function nextSlide() {
        goToSlide((current + 1) % slides.length);
    }
    function prevSlide() {
        goToSlide((current - 1 + slides.length) % slides.length);
    }
    nextBtn?.addEventListener("click", ()=>{
        nextSlide();
    });
    prevBtn?.addEventListener("click", ()=>{
        prevSlide();
    });
    gsap.set(slides, {
        zIndex: 1
    });
    gsap.set(slides[0], {
        zIndex: 2
    });
    slides[0].classList.add("is-current");
    animateTextIn(slides[0]);
    goToSlide(0);
}


parcelRequire("71MPf");
function $36e8edfd77f3eacd$export$cdf0a0b4b9a28c5f() {
    const wrapper = document.querySelector(".case-studies-progress-inner"), progressBar = document.querySelector(".case-studies-progress"), totalCaseStudies = document.querySelectorAll(".case-study-item-link").length, scroller = document.querySelector(".case-studies-spacer");
    if (!progressBar || !totalCaseStudies) return;
    gsap.fromTo(progressBar, {
        scaleY: 0
    }, {
        scaleY: 1,
        scrollTrigger: {
            trigger: scroller,
            start: "top top",
            end: "bottom bottom",
            scrub: true
        }
    });
}


// set hero sequence
document.addEventListener("DOMContentLoaded", function() {
    // setTimeout(() => {
    // Brand Core section
    ScrollTrigger.refresh();
    (0, $4f8dd14eb30e4f23$export$985150dac2e59f14)();
// setBrandCoreText();
// Set case studies logic
// initCaseStudies();
// initCaseStudiesSlider();
// initCaseStudiesProgress();
// initServicesList();
// }, 1000);
});

})();
//# sourceMappingURL=home.js.map
